module.exports = __webpack_public_path__ + "img/hr-red-pita-11.12640a78.png";